// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fIrt","tabsBox":"styles_tabsBox__2Ruac","createButton":"styles_createButton__3EOTq"};